import { ORPCError } from "@orpc/client";
import { ModerationRefusal, SurfaceBan } from "@pax/api-contract/moderation/v1alpha1";
import { REFUSAL_WARNINGS } from "@pax/moderation-copy";

/** Whether moderation stopped a save: automod refused it or couldn't check it, or a ban covers it. */
export function isModerationError(error: unknown): boolean {
  return (
    error instanceof ORPCError &&
    (error.code === "MODERATION_REFUSED" ||
      error.code === "AUTOMOD_UNAVAILABLE" ||
      error.code === "SURFACE_BANNED")
  );
}

/** The refusal a failed save carries, or null when automod didn't refuse it. */
export function moderationRefusal(error: unknown): ModerationRefusal | null {
  if (!(error instanceof ORPCError) || error.code !== "MODERATION_REFUSED") return null;
  return ModerationRefusal.safeParse(error.data).data ?? null;
}

/** The ban that stopped a save, or null when none did. */
export function surfaceBan(error: unknown): SurfaceBan | null {
  if (!(error instanceof ORPCError) || error.code !== "SURFACE_BANNED") return null;
  return SurfaceBan.safeParse(error.data).data ?? null;
}

/** The inline warning for a refusal's categories, naming every one. */
export function smallWarning(refusal: ModerationRefusal): string {
  return refusal.categories.map(({ category }) => REFUSAL_WARNINGS[category].small).join(" ");
}
